import { getInitialValues } from "layouts/views/common/common";
import * as Yup from "yup";

export const form = {
  formId: "new-consignee-form",
  formField: {
    consigneeCode: {
      name: "consigneeCode",
      label: "Consignee Code",
      type: "text",
      errorMsg: "Consignee code is required.",
    },
    customerCode: {
      name: "customerCode",
      label: "Customer Code",
      type: "text",
      errorMsg: "Customer code is required.",
      disabled: true,
    },
    // companyCode: {
    //   name: "companyCode",
    //   label: "Company Code",
    //   type: "text",
    //   errorMsg: "Company code is required.",
    // },
    consigneeName: {
      name: "consigneeName",
      label: "Consignee Name",
      type: "text",
      errorMsg: "Consignee name is required.",
    },
    consgShortName: {
      name: "consgShortName",
      label: "Consignee Short Name",
      type: "text",
      errorMsg: "Consignee short name is required.",
    },
    billCompany: {
      name: "billCompany",
      label: "Company",
      type: "text",
      errorMsg: "Billing company is required.",
    },
    billAddress1: {
      name: "billAddress1",
      label: "Address1",
      type: "text",
      errorMsg: "Billing address1 is required.",
    },
    billAddress2: {
      name: "billAddress2",
      label: "Address2",
      type: "text",
      errorMsg: "Billing address2 is required.",
    },
    billPostcode: {
      name: "billPostcode",
      label: "Postcode",
      type: "text",
      errorMsg: "Billing postcode is required.",
    },
    billCity: {
      name: "billCity",
      label: "City",
      type: "text",
      errorMsg: "Billing city is required.",
    },
    billState: {
      name: "billState",
      label: "State",
      type: "text",
      errorMsg: "Billing state is required.",
    },
    billCountry: {
      name: "billCountry",
      label: "Country",
      type: "text",
      errorMsg: "Billing country is required.",
    },
    billPhoneNo: {
      name: "billPhoneNo",
      label: "Phone No",
      type: "text",
      errorMsg: "Billing phone no is required.",
    },
    billFaxNo: {
      name: "billFaxNo",
      label: "Fax No",
      type: "text",
      errorMsg: "Billing fax no name is required.",
    },

    shipCompany: {
      name: "shipCompany",
      label: "Company",
      type: "text",
      errorMsg: "Shipping company is required.",
    },
    shipAddress1: {
      name: "shipAddress1",
      label: "Address1",
      type: "text",
      errorMsg: "Shipping address1 is required.",
    },
    shipAddress2: {
      name: "shipAddress2",
      label: "Address2",
      type: "text",
      errorMsg: "Shipping address2 is required.",
    },
    shipPostcode: {
      name: "shipPostcode",
      label: "Postcode",
      type: "text",
      errorMsg: "Shipping postcode is required.",
    },
    shipCity: {
      name: "shipCity",
      label: "City",
      type: "text",
      errorMsg: "Shipping city is required.",
    },
    shipState: {
      name: "shipState",
      label: "State",
      type: "text",
      errorMsg: "Shipping state is required.",
    },
    shipCountry: {
      name: "shipCountry",
      label: "Country",
      type: "text",
      errorMsg: "Shipping country is required.",
    },
    shipPhoneNo: {
      name: "shipPhoneNo",
      label: "Phone No",
      type: "text",
      errorMsg: "Shipping phone no is required.",
    },
    shipFaxNo: {
      name: "shipFaxNo",
      label: "Fax No",
      type: "text",
      errorMsg: "Shipping fax no name is required.",
    },

    contactPerson: {
      name: "contactPerson",
      label: "Contact Person",
      type: "text",
      errorMsg: "Contact person name is required.",
    },
    contactPhoneNo: {
      name: "contactPhoneNo",
      label: "Phone No",
      type: "text",
    },
    contactMobileNo: {
      name: "contactMobileNo",
      label: "Mobile No",
      type: "text",
      errorMsg: "Mobile no is required.",
    },
    contactEmail: {
      name: "contactEmail",
      label: "Email",
      type: "text",
    },
    useBackOrder: {
      name: "useBackOrder",
      label: "Allow Backorder",
      type: "switch",
      default: false,
    },
    fulfillInDays: {
      name: "fulfillInDays",
      label: "Fulfill In Days",
      type: "number",
    },
    orderShelfLife: {
      name: "orderShelfLife",
      label: "Order Shelf Life",
      type: "number",
    },
  },
  formRender: [
    [
      {
        name: "useBackOrder",
        label: "Allow Backorder",
        type: "switch",
      },
    ],
  ],
};

const formField = {
  consigneeCode: {
    name: "consigneeCode",
    label: "Consignee Code",
    type: "text",
    errorMsg: "Consignee code is required.",
    required: true,
    editable: false,
  },
  customerCode: {
    name: "customerCode",
    label: "Customer Code",
    type: "text",
    errorMsg: "Customer code is required.",
    disabled: true,
    required: true,
  },
  // companyCode: {
  //   name: "companyCode",
  //   label: "Company Code",
  //   type: "text",
  //   errorMsg: "Company code is required.",
  // },
  consigneeName: {
    name: "consigneeName",
    label: "Consignee Name",
    type: "text",
    errorMsg: "Consignee name is required.",
    required: true,
  },
  consgShortName: {
    name: "consgShortName",
    label: "Consignee Short Name",
    type: "text",
    errorMsg: "Consignee short name is required.",
    required: true,
  },
  billCompany: {
    name: "billCompany",
    label: "Company",
    type: "text",
    errorMsg: "Billing company is required.",
    required: true,
  },
  billAddress1: {
    name: "billAddress1",
    label: "Address1",
    type: "text",
    errorMsg: "Billing address1 is required.",
    required: true,
  },
  billAddress2: {
    name: "billAddress2",
    label: "Address2",
    type: "text",
    errorMsg: "Billing address2 is required.",
    required: true,
  },
  billPostcode: {
    name: "billPostcode",
    label: "Postcode",
    type: "text",
    errorMsg: "Billing postcode is required.",
    required: true,
  },
  billCity: {
    name: "billCity",
    label: "City",
    type: "text",
    errorMsg: "Billing city is required.",
    required: true,
  },
  billState: {
    name: "billState",
    label: "State",
    type: "select",
    errorMsg: "Billing state is required.",
    required: true,
  },
  billCountry: {
    name: "billCountry",
    label: "Country",
    type:"select",
    errorMsg: "Billing country is required.",
    required: true,
  },
  billPhoneNo: {
    name: "billPhoneNo",
    label: "Phone No",
    type: "text",
    errorMsg: "Billing phone no is required.",
    required: true,
  },
  billFaxNo: {
    name: "billFaxNo",
    label: "Fax No",
    type: "text",
    errorMsg: "Billing fax no name is required.",
  },

  shipCompany: {
    name: "shipCompany",
    label: "Company",
    type: "text",
    errorMsg: "Shipping company is required.",
    required: true,
  },
  shipAddress1: {
    name: "shipAddress1",
    label: "Address1",
    type: "text",
    errorMsg: "Shipping address1 is required.",
    required: true,
  },
  shipAddress2: {
    name: "shipAddress2",
    label: "Address2",
    type: "text",
    errorMsg: "Shipping address2 is required.",
    required: true,
  },
  shipPostcode: {
    name: "shipPostcode",
    label: "Postcode",
    type: "text",
    errorMsg: "Shipping postcode is required.",
    required: true,
  },
  shipCity: {
    name: "shipCity",
    label: "City",
    type: "text",
    errorMsg: "Shipping city is required.",
    required: true,
  },
  shipState: {
    name: "shipState",
    label: "State",
    type: "select",
    errorMsg: "Shipping state is required.",
    required: true,
  },
  shipCountry: {
    name: "shipCountry",
    label: "Country",
    type:"select",
    errorMsg: "Shipping country is required.",
    required: true,
  },
  shipPhoneNo: {
    name: "shipPhoneNo",
    label: "Phone No",
    type: "text",
    errorMsg: "Shipping phone no is required.",
    required: true,
  },
  shipFaxNo: {
    name: "shipFaxNo",
    label: "Fax No",
    type: "text",
    errorMsg: "Shipping fax no name is required.",
  },

  contactPerson: {
    name: "contactPerson",
    label: "Contact Person",
    type: "text",
    errorMsg: "Contact person name is required.",
    required: true,
  },
  contactPhoneNo: {
    name: "contactPhoneNo",
    label: "Phone No",
    type: "text",
  },
  contactMobileNo: {
    name: "contactMobileNo",
    label: "Mobile No",
    type: "text",
    errorMsg: "Mobile no is required.",
    required: true,
  },
  contactEmail: {
    name: "contactEmail",
    label: "Email",
    type: "text",
  },
  useBackOrder: {
    name: "useBackOrder",
    label: "Allow Backorder",
    type: "switch",
    default: false,
    size:3
  },
  fulfillInDays: {
    name: "fulfillInDays",
    label: "Fulfill In Days",
    type: "number",
    size:3
  },
  orderShelfLife: {
    name: "orderShelfLife",
    label: "Order Shelf Life",
    type: "number",
    size:3
  },
  applyBilling: {
    type: "button",
    name: "applyBilling",
    label: "Apply Billing",
  },
};

const {
  consigneeCode,
  customerCode,
  consigneeName,
  consgShortName,
  billCompany,
  billAddress1,
  billAddress2,
  billPostcode,
  billCity,
  billState,
  billCountry,
  billPhoneNo,
  billFaxNo,
  shipCompany,
  shipAddress1,
  shipAddress2,
  shipPostcode,
  shipCity,
  shipState,
  shipCountry,
  shipPhoneNo,
  shipFaxNo,
  contactPerson,
  contactPhoneNo,
  contactMobileNo,
  contactEmail,
  useBackOrder,
  fulfillInDays,
  orderShelfLife,
  applyBilling
} = formField;

export const formRender = [
  [consigneeCode, customerCode, consigneeName, consgShortName],
  [
    { type: "title", label: "Billing Address" },
    { type: "title", label: "Shipping Address" },
  ],
  [billCompany, billCity, shipCompany, shipCity],
  [billAddress1, billState, shipAddress1, shipState],
  [billAddress2, billCountry, shipAddress2, shipCountry],
  [billPostcode, billPhoneNo, shipPostcode, shipPhoneNo],
  [billFaxNo,applyBilling, shipFaxNo,""],
  [{ type: "title", label: "Contact Info" }],
  [contactPerson, contactMobileNo, contactPhoneNo, contactEmail],
  [{ type: "title", label: "Process Control" }],
  [useBackOrder, fulfillInDays, orderShelfLife],
];

export const initialValues = getInitialValues(formField);

export const consigneeValidations = Yup.object().shape({
  [consigneeCode.name]: Yup.string().nullable().max(20).required(consigneeCode.errorMsg),
  [customerCode.name]: Yup.string().nullable().max(20).required(customerCode.errorMsg),
  //[companyCode.name]: Yup.string().max(20).required(companyCode.errorMsg),
  [consigneeName.name]: Yup.string().nullable().max(100).required(consigneeName.errorMsg),
  [consgShortName.name]: Yup.string().nullable().max(30).required(consgShortName.errorMsg),
  [billCompany.name]: Yup.string().nullable().max(100).required(billCompany.errorMsg),
  [billAddress1.name]: Yup.string().nullable().max(200).required(billAddress1.errorMsg),
  [billAddress2.name]: Yup.string().nullable().max(200).required(billAddress2.errorMsg),
  [billPostcode.name]: Yup.string().nullable().max(10).required(billPostcode.errorMsg),
  [billCity.name]: Yup.string().nullable().max(100).required(billCity.errorMsg),
  [billState.name]: Yup.string().nullable().max(100).required(billState.errorMsg),
  [billCountry.name]: Yup.string().nullable().max(100).required(billCountry.errorMsg),
  [billPhoneNo.name]: Yup.string().nullable().max(20).required(billPhoneNo.errorMsg),
  [billFaxNo.name]: Yup.string().nullable().max(20),
  [shipCompany.name]: Yup.string().nullable().max(100).required(shipCompany.errorMsg),
  [shipAddress1.name]: Yup.string().nullable().max(200).required(shipAddress1.errorMsg),
  [shipAddress2.name]: Yup.string().nullable().max(200).required(shipAddress2.errorMsg),
  [shipPostcode.name]: Yup.string().nullable().max(20).required(shipPostcode.errorMsg),
  [shipCity.name]: Yup.string().nullable().max(100).required(shipCity.errorMsg),
  [shipState.name]: Yup.string().nullable().max(100).required(shipState.errorMsg),
  [shipCountry.name]: Yup.string().nullable().max(100).required(shipCountry.errorMsg),
  [shipPhoneNo.name]: Yup.string().nullable().max(20).required(shipPhoneNo.errorMsg),
  [shipFaxNo.name]: Yup.string().nullable().max(20),
  [contactPerson.name]: Yup.string().nullable().max(100).required(contactPerson.errorMsg),
  [contactMobileNo.name]: Yup.string().nullable().max(20).required(contactMobileNo.errorMsg),
});
